(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["social-share-buttons"]) return;
  try {
    
  var block = $('.social-share-buttons');
  var count = 0;
  getCounters();

  function getCounters() {
    getFacebookCounters();
    getPinterestCounters();
  }

  window.receivePinterestCount = function(result) {
    count = count + result.count;
    updateTotalCounter();
    block.find('.share-pinterest .shares-count').text(result.count);
  }

  function getPinterestCounters() {
    var url = "//facebook.com";
    var apiUrl = "//api.pinterest.com/v1/urls/count.json?callback=receivePinterestCount&url=" + window.location.href.replace(window.location.search, '');

    $.ajax({
      url: apiUrl,
      dataType: "jsonp",
    });
  }

  function getFacebookCounters() {
      var fbGraphUrl = '//graph.facebook.com/' + window.location.href.replace(window.location.search, '');

      $.getJSON(fbGraphUrl).done(function(data) {
        count = count + data.share.share_count;
        updateTotalCounter();
        block.find('.share-facebook .shares-count').text(data.share.share_count);
      });
  }

  function updateTotalCounter() {
      block.find('.total-shares .shares-count').text(count);
  }

  } catch(e) { console.error(e); }
})();
})();
